import type { ElementType, HTMLAttributes } from 'react';
import clsx from 'clsx';

type Props = HTMLAttributes<HTMLElement> & { as?: ElementType };

// The site's one container for a group of things to read or download: white, thin
// border, the heading INSIDE it. (Home's notice board and E-Journal cards, the
// Notices list, and every list on the inner pages.)
export function Card({ as: Tag = 'div', className, ...rest }: Props) {
  return (
    <Tag className={clsx('border border-rule bg-white p-[clamp(20px,3vw,28px)]', className)} {...rest} />
  );
}

// Heading style used at the top of a Card.
export const CARD_TITLE = 'm-0 mb-4 font-serif text-[1.75rem] font-semibold text-navy-900';
